import { render, staticRenderFns } from "./settingInterfaceWeb.vue?vue&type=template&id=67175dd4&scoped=true&"
import script from "./settingInterfaceWeb.vue?vue&type=script&lang=js&"
export * from "./settingInterfaceWeb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67175dd4",
  null
  
)

export default component.exports